import { mount } from 'svelte';
import Otvirak from './Otvirak.svelte';

mount(Otvirak, {
    target: document.getElementById('svelte-root')!,
});
